import axios from "axios";

const API = "/api";

const getWithRetry = (url, params, tries = 3) =>
  axios.get(url, { params, timeout: 12000 }).then(r => r.data).catch(err => {
    if (tries > 1) return new Promise(res => setTimeout(res, 1200)).then(() => getWithRetry(url, params, tries - 1));
    throw err;
  });

export const productThumb = (p) => `/images/products/${p.slug}.webp`;

export const api = {
  getProducts: (params = {}) => getWithRetry(`${API}/products`, params),
  getProduct: (slug) => getWithRetry(`${API}/products/${slug}`),
  getGallery: () => getWithRetry(`${API}/gallery`),
  getBlogPosts: () => getWithRetry(`${API}/blog`),
  getBlogPost: (slug) => getWithRetry(`${API}/blog/${slug}`),
  submitContact: (data) => axios.post(`${API}/contact`, data).then(r => r.data),
};
